import request from '@/lib/api'

const _BASE = "";

export function getOperationList(params) {
    return request({
        url: `${_BASE}/api/tPmcLog/operationLogList`,
        params
    })
}
export function getCallList(params) {
    return request({
        url: `${_BASE}/api/tPmcLog/callLogList`,
        params
    })
}